export class DetalleTransaccion {
    public transaccionId: number;
    public nombre: string;
    public sNombre: string;
    public apellidoPaterno: string;
    public apellidoMaterno: string;
    public instrumento: string;
    public referencia: string;
    public fechaRegistro: string;
    public tipoCambioDof: string;
    public tipoCambioFix: string;
    public tipoCambioObl: string;
    public tipoOperacion: string;
    public sucursal: string;
    public insitucionFinanciera: string;
    public divisa: string;
    public noCheque: string;
    public saldo: string;
    public tFechaPago: string;
    public tMontoTotal: string;
    public diasTranscurridos: number;
    public totalRegistros: number;
    public contrato: string;
    public latitud: number;
    public longitud: number;
    public estadoGeolocaliza: string;
    public municipioGeolocaliza: string;
    public localidadGeolocaliza: string;
    public perfil: any;
    public producto: any;
    public esCancelada: number;
    public tipoOpervw: string;
    public bancoOrigenTran: string;
    public cuentaOrigen: string;
    public nombreOrigen: string;
    public contraparte: string;
    public numeroCuenta: string;
    public banco: string;
    public seleccionado: number;
    public CasoId: number;
    public clavecia: string;
    public siprev: string;
    public geolocalizacionPago: string;
    public ultimaTransaccion: number;
    public institucionFinanciera: string;
    public cuentaClabe: string;
    public entradaSalida: number;
    public tipoAfectacion: string;
    public formaDePago: number;
    public tipoPago: string;
    public clearingDoc: string;
    public marca: string;
    public auto: string;
    public modelo: string;
    public chasis: string;
    public cargosAdicionales: string;
    public montoNeto: string;
    public facturaNumero: number;
    public documentoFecha: string;
    public documentoNumero: number;
    public base: string;
    public rfc: string;
    public pais: string;
    public saldoCredito: string;
    public tipoTarjeta: string;
    public anio: number;
    public numInscripcion: string;
    public placas: string;
    public nivelBlindaje: string;
    public banderaId: string;
    public formaPago: string;
    public importeFactura: string;
    public importeISAN: string;
    public recibo: string;
    public fechaCancelacionRecibo: string;
    public estatusRecibo: string;
    public tipoGarantia: string;
    public tipoInmueble: string;
    public valorReferencia: string;
    public codigoPostalInmueble: string;
    public folio: string;
    public descripcionGarantia: string;
    public cancelado: number;
    public fechaInicio: string;
    public fechaFin: string;
    public claveActividad: string;
    public fechaPago: string;
    public tipoVehiculo: string;
    public facturaReferencia: string;
    public importeIVA: string;
    public subTotalsinIVA: string;


    constructor() {
        this.transaccionId = 0;
        this.nombre = '';
        this.sNombre = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.instrumento = '';
        this.referencia = '';
        this.fechaRegistro = '';
        this.tipoCambioDof = '';
        this.tipoCambioObl = '';
        this.tipoCambioFix = '';
        this.tipoOperacion = '';
        this.sucursal = '';
        this.insitucionFinanciera = '';
        this.divisa = '';
        this.noCheque = '';
        this.saldo = '';
        this.tFechaPago = '';
        this.tMontoTotal = '';
        this.diasTranscurridos = 0;
        this.totalRegistros = 0;
        this.contrato = '';
        this.esCancelada = 0;
        this.tipoOpervw = '';
        this.bancoOrigenTran = '';
        this.cuentaOrigen = '';
        this.nombreOrigen = '';
        this.siprev = '';
        this.marca = '';
        this.auto = '';
        this.modelo = '';
        this.chasis = '';
        this.cargosAdicionales = '';
        this.montoNeto = '';
        this.facturaNumero = 0;
        this.documentoFecha = '';
        this.documentoNumero = 0;
        this.base = '';
        this.rfc = '';
        this.pais = '';
        this.saldoCredito = '';
        this.tipoTarjeta = '';
        this.anio = 0;
        this.numInscripcion = '';
        this.placas = '';
        this.nivelBlindaje = '';
        this.banderaId = '';
        this.formaPago = '';
        this.importeFactura = '';
        this.importeISAN = '';
        this.recibo = '';
        this.fechaCancelacionRecibo = '';
        this.estatusRecibo = '';
        this.tipoGarantia = '';
        this.tipoInmueble = '';
        this.valorReferencia = '';
        this.codigoPostalInmueble = '';
        this.folio = '';
        this.descripcionGarantia = '';
        this.cancelado = 0;
        this.fechaInicio = '';
        this.fechaFin = '';
        this.claveActividad = '';
        this.fechaPago = '';
        this.tipoVehiculo = '';
        this.facturaReferencia = '';
        this.importeIVA = '';
        this.subTotalsinIVA = '';

    }
}
